import useFilterSearchParams from 'common/hooks/useFilterSearchParams';
import { UsersFilter, usersFilterSearchParams } from 'common/types/SearchParams';

import { useFormik } from 'formik';

const useUsersFilter = (onSubmit: () => void) => {
  const { params, setFilter, clearFilter } = useFilterSearchParams<UsersFilter>(usersFilterSearchParams);

  const formikSubmit = (params: UsersFilter) => {
    setFilter(params);
    onSubmit();
  };

  const formik = useFormik<UsersFilter>({
    initialValues: params,
    onSubmit: formikSubmit,
    enableReinitialize: true,
  });

  const clearFormAndSearchParams = () => {
    formik.resetForm();
    clearFilter();
  };

  return { formik, clearFormAndSearchParams };
};

export default useUsersFilter;
